import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { UpDatesService } from './up-dates.service';
import { LoaderService } from 'src/app/common/loader.service';
import swal from 'sweetalert2';
import * as CommonConstants from '../../utils/common.constants';
import { MasterService } from 'src/app/masters/master.service';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-up-dates',
  templateUrl: './up-dates.component.html',
  styleUrls: ['./up-dates.component.scss']
})
export class UpDatesComponent implements OnInit {

  @Input()
  medfiId;

  @Input()
  hospiId;

  @Input()
  medicalFileDtls;

  PARAM_KEY=[CommonConstants.STATUS, CommonConstants.SERVICE, CommonConstants.EMERGENCY, CommonConstants.CONSLATION_TYPE, CommonConstants.HOSPI_REASON, CommonConstants.PROCEDURE_NAMES, 'ROOM_TYPE', 'BED_TYPE' ];
  SERVICES=['MED_NOTES', 'MED_OPD_CARES', 'MED_CONSULTATION', 'MED_HOSP_HOSPITALIZATION'];
  ptype = [CommonConstants.PARTNER_HOSPITAL_TYPE, CommonConstants.PARTNER_PRACTITIONER_TYPE];
  masterValues=[];
  statusMaster = [];
  specialities = [];
  hospitalMaster = [];
  partnerList = [];
  specialistList = [];

  notesRowData = [];
  consultationData = [];

  hospitalizationRowData = [];
  opdCareRowData = [];

  frameworkComponents;
  notesDefs;
  hospitalizationDefs;
  opdCareDefs;
  consultationForm: FormGroup;
  
  notesGridApi: GridApi;
  hospitalizationGridApi: GridApi;
  opdCareGridApi: GridApi;
  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }
  bedTypeMaster: any[];
  serviceMaster: any[];
  emergencyMaster: any[];
  consTypeMaster: any[];
  hospiReasonMaster: any[];
  procNamesMaster: any[];
  roomTypeMaster: any[];
  languages=[];
  address=[];
  constructor(private modal: NgbModal, private service: UpDatesService, private fb: FormBuilder, private loaderService: LoaderService, private router: Router, private masterService: MasterService) {
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
    
  }

  ngOnInit() {
    this.masterService.getPartnersByPartnerType(this.ptype);
    this.loadMaster();
    this.loadData();
    this.consultationForm = this.fb.group({
      medcoId: [null],
      hospiId: [null],
      language: [''],
      medcoDtDate: [''],
      medcoDtPlanDate: [''],
      medcoDtRepStartTime: [''],
      medcoVaAcceptedBy: [''],
      medcoVaActionToBeTaken: [''],
      medcoVaComment: [''],
      medcoVaContactPerson: [''],
      medcoVaPatientFollowBy: [''],
      medcoVaPlanBy: [''],
      medcoVaReason: [''],
      medcoVaRepAssessment: [''],
      medcoVaRepBmi: [''],
      medcoVaRepBpLeft: [''],
      medcoVaRepBpRight: [''],
      medcoVaRepDiagnostic: [''],
      medcoVaRepHight: [''],
      medcoVaRepObjectSign: [''],
      medcoVaRepPoul: [''],
      medcoVaRepSubjectSign: [''],
      medcoVaRepTemp: [''],
      medcoVaRepWeight: [''],
      medcoVaTelephone: [''],
      medfiId: [null],
      planEmergency: [''],
      planService: [''],
      planType: [''],
      pradrId: [null],
      prtieId: [null],
      spltyId: [null],
      staRecCode: ['A'],
      statuCode: ['']
    });

    this.notesDefs = [
      { headerName: 'Date/Time', field: 'mednoDtDate', cellEditor: 'agDateInput', width: 150},
      { headerName: 'Title', field: 'mednoVaTitle'},
      { headerName: 'Notes', field: 'mednoVaContent' }
    ];

    this.opdCareDefs = [
      { headerName: 'Hospital', field: 'hospiId', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.hospitalMaster, dataColumn: 'hospiId', model: new Parameter(), objectData: ['hospiId', 'description'] }
      },
      { headerName: 'Prescription Date', field: 'medocDtPrescription', cellEditor: 'agDateInput'},
      { headerName: 'Realisation Date', field: 'medocDtRealisation', cellEditor: 'agDateInput'},
      { headerName: 'Description', field: 'medocVaDescription' },
      { headerName: 'Operator', field: 'medocVaOperator' },
      { headerName: 'Status', field: 'status', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.statusMaster, dataColumn: 'statuCode', model: new Parameter(), objectData: ['statuCode', 'description'] }
      }
    ];
  }

  loadMaster() {
    this.loaderService.display(true);
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
       if (response && response['result']) {
        this.masterValues = response['result'];
        this.statusMaster = this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
        this.serviceMaster = this.masterValues.filter(master => master.paramKey === CommonConstants.SERVICE);
        this.emergencyMaster = this.masterValues.filter(master => master.paramKey === CommonConstants.EMERGENCY);
        this.consTypeMaster = this.masterValues.filter(master => master.paramKey === CommonConstants.CONSLATION_TYPE);
        this.hospiReasonMaster = this.masterValues.filter(master => master.paramKey === CommonConstants.HOSPI_REASON);
        this.procNamesMaster = this.masterValues.filter(master => master.paramKey === CommonConstants.PROCEDURE_NAMES);
        this.roomTypeMaster = this.masterValues.filter(master => master.paramKey === 'ROOM_TYPE');
        this.bedTypeMaster = this.masterValues.filter(master => master.paramKey === 'BED_TYPE');
        this.loaderService.display(false);
       }
     });
     this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result']
      }
     })
     this.masterService.getLanguages().subscribe(res => {
      if (res && res["result"]) {
        this.languages = res["result"];
      }
    })
     /* setTimeout(() => {
      this.masterService.getPartners().subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    }, 500); */
    this.masterService.getParnterListByParnterTypes(this.ptype).subscribe(value => {
      this.partnerList = value['result'];
      this.setPartners();
      //this.filterPartnerTypes();    
    });

   }

   setPartners() {
    this.specialistList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
    this.hospitalMaster = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_HOSPITAL_TYPE);
  }

   loadData() { 
     this.loaderService.display(true);
     this.service.getFileData(this.medfiId, this.SERVICES).subscribe(res => {
      this.loaderService.display(false);
       if(res['code'] === 'S0000'){
        this.notesRowData = res['result']['MED_NOTES'];
        this.opdCareRowData = res['result']['MED_OPD_CARES'];
        this.hospitalizationRowData = res['result']['MED_HOSP_HOSPITALIZATION'];
        this.consultationData = res['result']['MED_CONSULTATION'];
        // this.consultationData = [{"createdTime":"04-10-2020 21:36","modifiedTime":"04-10-2020 21:36","createdUser":"Super","modifiedUser":"Super","medcoId":2,"hospiId":null,"language":"","medcoDtDate": "04-10-2020 21:36","medcoDtPlanDate":"04-10-2020 21:36","medcoDtRepStartTime":null,"medcoVaAcceptedBy":"xasasd","medcoVaActionToBeTaken":"","medcoVaComment":"asdasd","medcoVaContactPerson":"asdasd","medcoVaPatientFollowBy":"","medcoVaPlanBy":"","medcoVaReason":"","medcoVaRepAssessment":"","medcoVaRepBmi":"","medcoVaRepBpLeft":"","medcoVaRepBpRight":"","medcoVaRepDiagnostic":"","medcoVaRepHight":"","medcoVaRepObjectSign":"","medcoVaRepPoul":"","medcoVaRepSubjectSign":"","medcoVaRepTemp":"","medcoVaRepWeight":"","medcoVaTelephone":"","medfiId":null,"planEmergency":"","planService":"","planType":"asd","pradrId":null,"prtieId":null,"spltyId":null,"staRecCode":"A","statuCode":""}];
        // console.log(this.consultationData)
      }
     })
   }

  // add note
  addNotesModal(addNotes){
    this.modal.open(addNotes, { size: 'lg', container: '.page-content' });
  }
  addNewNote() {
    const newRow = { medfiId: this.medfiId, medNoId: null, mednoDtDate: '',  mednoVaTitle: '', mednoVaContent: '', staRecCode: 'A' };
    this.notesRowData.push(newRow);
    this.notesGridApi.setRowData(this.notesRowData);
    // var firstEditCol = params.columnApi.getAllDisplayedColumns()[0];
  // params.api.ensureColumnVisible(firstEditCol );

// sets focus into the first grid cell
// params.api.setFocusedCell(params.rowIndex, firstEditCol);  

  }
  onGridReadyNotes(params) {
    this.notesGridApi = params.api;
    this.notesGridApi.sizeColumnsToFit();
  }


  // add Consultation plan
  addConsultationModal(addConsultation, data?){
    this.modal.open(addConsultation, { size: 'lg', windowClass: 'full-width', container: '.page-content' }); 
    if(data) { 
      this.consultationForm.patchValue(data.data)
    }   
  }
  

  
  onGridReadyHospitalization(params) {
    this.hospitalizationGridApi = params.api;
    this.hospitalizationGridApi.sizeColumnsToFit();
  }
  
  // add OPD care   
  addOpdCareModal(addOpdCare){
    this.modal.open(addOpdCare, { size: 'lg', container: '.page-content' }); 
  }
  addNewOpdCare() {
    const newRow = { medocDtPrescription: '',  medocDtRealisation: '', medocVaDescription: '', medocVaOperator: '', statuCode: '', medfiId: this.medfiId, staRecCode: 'A', medocId: null, medocVaCode: 'vacode' };
    this.opdCareRowData.push(newRow);
    this.opdCareGridApi.setRowData(this.opdCareRowData);
  }
  onGridReadyOpdCare(params) {
    this.opdCareGridApi = params.api;
    this.opdCareGridApi.sizeColumnsToFit();
  }

  cleanupRows(gridName: string) { 
    const notesColumns = ['mednoDtDate', 'mednoVaContent', 'mednoVaTitle'];
    const opdColumns = ['medocDtPrescription', 'medocDtRealisation', 'medocVaCode', 'medocVaDescription', 'medocVaOperator', 'statuCode'];

    let targetRowData = [];
    let targetColumns = [];
    let emptyRowsIndex = [];
    
    switch(gridName){
      case 'notes': {
        targetRowData = this.notesRowData;
        targetColumns = notesColumns;
        break;
      }

      case 'opdCare': {
        targetRowData = this.opdCareRowData;
        targetColumns = opdColumns;
        break;
      }
      default: return;
    }

    targetRowData.forEach((row, index) => {
      let empty = true;
      targetColumns.map(key => {
        if(row[key]){
          empty = empty && false;
        }
      })
      if(empty){
        emptyRowsIndex.push(index);
      }
    })

    emptyRowsIndex.slice().reverse().forEach(index => {
      targetRowData.splice(index, 1);
    })

  }

  saveNotes() { 
    this.notesGridApi.stopEditing();
    this.cleanupRows('notes');
    
    let jsonData = this.notesRowData.map(note => ({
      ...note,
      'secUsrId': note.secUsrId || +localStorage.getItem(CommonConstants.USERID),
    }))

    
    this.service.saveNotes(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        swal.fire("Saved successfully", '','success');
        this.notesRowData = res["result"];
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error","Error Occured While Saving Notes",'error');
    })

  }

  saveConsultation() { 
    let data = {
      ...this.consultationForm.value,
      medcoDtPlanDate: this.consultationForm.value.medcoDtPlanDate ? moment(this.consultationForm.value.medcoDtPlanDate).format("DD-MM-YYYY HH:mm") : '',
      medcoDtDate: this.consultationForm.value.medcoDtDate ? moment(this.consultationForm.value.medcoDtDate).format("DD-MM-YYYY HH:mm") : '',
      medcoDtRepStartTime: this.consultationForm.value.medcoDtRepStartTime ? moment(this.consultationForm.value.medcoDtRepStartTime).format("DD-MM-YYYY HH:mm") : ''
    }
    this.service.saveConsultation(data).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        swal.fire("Saved successfully", '','success');
        this.consultationForm.patchValue(res["result"]);
        this.consultationData.push(this.consultationForm.value);
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error","Error Occured While Saving Consultation",'error');
    })
  }

  saveOpdCare() { 
    this.opdCareGridApi.stopEditing();
    this.cleanupRows('opdCare');

    //TODO: Remove this block after ng Select issue sorted
    this.opdCareRowData.forEach(item => {
      // item.hospiId = this.hospitalMaster.filter(x => x.description === item.hospiId)[0].hospiId;
      item.status = this.statusMaster.filter(x => x.description === item.status)[0].statuCode;
    })
    
    this.service.saveOpdCare(this.opdCareRowData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        this.opdCareRowData = res["result"];
        swal.fire("Saved successfully!", '','success');
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error","Error Occured While Saving OPD Care",'error');
    })

  }
  
  openHospitalizationScreen(data?) { 
    data ? 
      this.router.navigate(['/addHospitalization'], { 
        state: { 
          details: {
            medfiId: this.medfiId,
            hospiId: this.hospiId,
            medicalFileDtls: this.medicalFileDtls,
            medhpId: data.data.medhpId
          } 
        }
      })
        :
      this.router.navigate(['/addHospitalization'], { 
        state: { 
          details: {
            medfiId: this.medfiId,
            hospiId: this.hospiId,
            medicalFileDtls: this.medicalFileDtls
          } 
        }
      })
  }
  

}
